var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-popup',{staticClass:"reprint-modal",attrs:{"title":"Opnieuw afdrukken","active":_vm.showPopup},on:{"update:active":function($event){_vm.showPopup=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }